import store from '@/store/store';
import { getAll as getAllDemandeLogistique } from '@/api/logistique/demandeLogistique';
import { getAll as getAllDemandeImpression } from '@/api/logistique/demandeImpression';
import { LISTE_COLUMNS_SUIVI_PRODUCTION } from '@/configuration/logistique/suiviProduction/suiviProductionConfig';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { INTERVENTION_TYPE_INTERVENTION } from '@/configuration/logistique/intervention/interventionConf';
import { FABRICATION_DISPOSITIF, DISPOSITIF_FABRIQUE } from '@/configuration/logistique/typeOt/typeOtConfig';
import { CATEGORIE_DISPOSITIF } from '@/configuration/catalogue/produitConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { mapDemandeLogistiqueToDemandeSuiviProduction, mapDemandeImpressionToDemandeSuiviProduction } from '@/services/logistique/suiviProduction/mappingForDemandeSuiviProduction';
import i18n from '@/i18n';
import VALIDATIONS from '@/services/logistique/suiviProduction/validationColumnSuiviProduction';
import { getMessageCount } from '@/api/gestionMessage';
import { gestionDemandesEnAttente } from '@/services/logistique/suiviProduction/gestionDemandeEnAttente';
import { cloneDeep } from 'lodash';

export function generateColumnsSuiviProduction() {
  return LISTE_COLUMNS_SUIVI_PRODUCTION.reduce((acc, column) => {
    acc[column] = {
      title: i18n.t(`suiviProduction.columns.${column}`),
      data: [],
    };
    return acc;
  }, {});
}
async function loadDemandeImpressionForCard() {
  const critereRechercheStore = store.getters['suiviProduction/criteresRecherche'];
  const payload = {
    limit: NO_PAGINATION,
    query: {
      auto: critereRechercheStore.auto,
      avecLogo: true,
      ligneCategorieVenteAssocie: [CATEGORIE_DISPOSITIF],
      societeId: store.getters['societe/societeActiveId'],
      agencesIds: store.getters['societe/agenceActive'].map((agence) => agence.agenceId),
      excludeCommandeFacturee: true,
      commercialIds: critereRechercheStore.commercialIds,
      assistantIds: critereRechercheStore.assistantIds,
      typeOtVisibleSuiviProd: false,
    },
    sorting: 'LigneCommande.DevisCommande.Code DESC,DateDemande DESC',
  };
  const payloadDuplicata = {
    limit: NO_PAGINATION,
    query: {
      auto: critereRechercheStore.auto,
      avecLogo: true,
      societeId: store.getters['societe/societeActiveId'],
      agencesIds: store.getters['societe/agenceActive'].map((agence) => agence.agenceId),
      excludeCommandeFacturee: true,
      commercialIds: critereRechercheStore.commercialIds,
      assistantIds: critereRechercheStore.assistantIds,
      typeOtVisibleSuiviProd: true,
      hasLigneCommande: true,
    },
    sorting: 'LigneCommande.DevisCommande.Code DESC,DateDemande DESC',
  };
  await store.dispatch('parametres/loadParametres', [PARAMETRES_KEYS.typeOt]);
  const typesOT = store.getters['parametres/parametre'](PARAMETRES_KEYS.typeOt);
  const [response1, response2] = await Promise.all([
    getAllDemandeImpression(payload),
    getAllDemandeImpression(payloadDuplicata),
  ]);
  const demandesImpression = [
    ...response1.data.result.items,
    ...response2.data.result.items,
  ];
  return demandesImpression.map(demande => mapDemandeImpressionToDemandeSuiviProduction(demande,
    typesOT));
}
async function loadDemandeInterventionForCard() {
  const critereRechercheStore = store.getters['suiviProduction/criteresRecherche'];
  const payload = {
    limit: NO_PAGINATION,
    query: {
      auto: critereRechercheStore.auto,
      ligneCategorieVente: [CATEGORIE_DISPOSITIF],
      types: [INTERVENTION_TYPE_INTERVENTION],
      actionIntervention: [DISPOSITIF_FABRIQUE, FABRICATION_DISPOSITIF],
      societeId: store.getters['societe/societeActiveId'],
      agencesIds: store.getters['societe/agenceActive'].map((agence) => agence.agenceId),
      commercialIds: critereRechercheStore.commercialIds,
      assistantIds: critereRechercheStore.assistantIds,
      excludeCommandeFacturee: true,
    },
    sorting: 'LigneCommande.DevisCommande.Code DESC,DatePlanification DESC',
  };
  const result = (await getAllDemandeLogistique(payload)).data.result.items;
  await store.dispatch('parametres/loadParametres', [PARAMETRES_KEYS.typeOt]);
  const typesOT = store.getters['parametres/parametre'](PARAMETRES_KEYS.typeOt);
  return result.map(demande => mapDemandeLogistiqueToDemandeSuiviProduction(demande, typesOT));
}

export function dispatchDataInColumnsSuiviProduction(columns, data, fromTop = false) {
  const newColumns = cloneDeep(columns);
  const columnsKeys = Object.keys(newColumns);
  data.forEach(demande => {
    const targetColumn = columnsKeys.find(key => {
      return !!VALIDATIONS[key] && VALIDATIONS[key](demande);
    });
    if (targetColumn && !!newColumns[targetColumn]) {
      if (fromTop) {
        newColumns[targetColumn].data.unshift(demande);
      } else {
        newColumns[targetColumn].data.push(demande);
      }
    }
  });
  return newColumns;
}

export async function generateDataSuiviProduction() {
  const columns = generateColumnsSuiviProduction();
  const [
    demandeImpression,
    demandeIntervention,
  ] = await Promise.all([
    loadDemandeImpressionForCard(),
    loadDemandeInterventionForCard(),
  ]);

  const demandes = [
    ...demandeImpression,
    ...gestionDemandesEnAttente(demandeIntervention),
  ];

  const demandeIds = demandes.map(d => d.id);
  const demandeNbMessages = (await getMessageCount(demandeIds)).data.result;

  demandes.forEach(demande => {
    demande.nbMessage = demandeNbMessages[demande.id];
  });
  return dispatchDataInColumnsSuiviProduction(columns, demandes);
}
